export default "__VITE_ASSET__Brg6U_3I__"